/* eslint-disable */
import es from "./es.json";
import en from "./en.json";
import fr from "./fr.json";
import de from "./de.json";
/* eslint-enable */

export * from "./hooks";

export const locales = {
  en,
  es,
  fr,
  de,
};

export function getLocaleMessages(locale) {
  const messages = locales[locale];
  if (!messages) {
    console.warn(`Unknown locale ${locale}, falling back to en`, locale);
    return locales.en;
  }
  return messages;
}
